var _rect, _rect2, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionMap2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 122,
    viewBox: "0 0 188 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.84122,
    y: 1.84122,
    width: 59.3176,
    height: 118.318,
    fill: "#35DDD3",
    fillOpacity: 0.4,
    stroke: "#35C9DD",
    strokeWidth: 3.68244
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 122
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 122,
    fill: "#6BDD35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_400)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 97,
    r: 18,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 100,
    r: 18,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 97,
    r: 18,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 95,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 97,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 99,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 106,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 97,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 100,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 102,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 106,
    r: 29,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 108.5,
    r: 19.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 108.5,
    r: 19.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 92.5,
    r: 11.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 87.5,
    r: 11.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 86.5,
    r: 11.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 85.5,
    r: 14.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 84.5,
    r: 14.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 82.5,
    r: 14.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.5,
    cy: 78.5,
    r: 14.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.5,
    cy: 78.5,
    r: 14.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 100.5,
    r: 14.5,
    fill: "#349584",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 18,
    fill: "#349584",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.016 93.5312C155.359 93.5391 157.578 94.9375 157.578 99.0469C157.586 102.891 155.766 105.156 152.922 105.156C150.648 105.156 149.086 103.727 148.859 101.812H151.172C151.367 102.648 152.016 103.141 152.922 103.141C154.461 103.141 155.273 101.758 155.281 99.5H155.188C154.656 100.5 153.539 101.094 152.281 101.094C150.25 101.094 148.75 99.5625 148.734 97.4531C148.734 95.1797 150.461 93.5234 153.016 93.5312ZM151.031 97.3906C151.031 98.5078 151.852 99.375 153.016 99.375C154.164 99.375 155.047 98.4609 155.047 97.375C155.031 96.2969 154.188 95.3828 153.031 95.375C151.875 95.3828 151.016 96.2656 151.031 97.3906ZM163.297 93.5312C165.641 93.5391 167.859 94.9375 167.859 99.0469C167.867 102.891 166.047 105.156 163.203 105.156C160.93 105.156 159.367 103.727 159.141 101.812H161.453C161.648 102.648 162.297 103.141 163.203 103.141C164.742 103.141 165.555 101.758 165.562 99.5H165.469C164.938 100.5 163.82 101.094 162.562 101.094C160.531 101.094 159.031 99.5625 159.016 97.4531C159.016 95.1797 160.742 93.5234 163.297 93.5312ZM161.312 97.3906C161.312 98.5078 162.133 99.375 163.297 99.375C164.445 99.375 165.328 98.4609 165.328 97.375C165.312 96.2969 164.469 95.3828 163.312 95.375C162.156 95.3828 161.297 96.2656 161.312 97.3906ZM176.109 99.3438C174.414 99.3438 173.5 98.1094 173.5 96.3281C173.5 94.5391 174.461 93.2969 176.109 93.2969C177.805 93.2969 178.711 94.5391 178.719 96.3281C178.711 98.125 177.781 99.3438 176.109 99.3438ZM175.094 96.3281C175.102 97.3047 175.453 97.9453 176.109 97.9531C176.781 97.9453 177.117 97.3047 177.125 96.3281C177.117 95.3516 176.812 94.6875 176.109 94.6875C175.445 94.6953 175.102 95.3672 175.094 96.3281ZM175.125 105L182.906 93.6875H184.656L176.875 105H175.125ZM181.141 102.359C181.141 100.57 182.102 99.3359 183.734 99.3281C185.445 99.3359 186.352 100.57 186.359 102.359C186.352 104.156 185.422 105.375 183.734 105.375C182.055 105.375 181.141 104.141 181.141 102.359ZM182.734 102.359C182.742 103.336 183.094 103.984 183.734 103.984C184.422 103.984 184.758 103.336 184.766 102.359C184.758 101.383 184.445 100.719 183.734 100.734C183.078 100.727 182.742 101.398 182.734 102.359Z",
    fill: "#CDD0DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.766 12.6875V24H151.406V14.9219H151.344L148.75 16.5469V14.4688L151.547 12.6875H153.766ZM163.047 18.3438C161.352 18.3438 160.438 17.1094 160.438 15.3281C160.438 13.5391 161.398 12.2969 163.047 12.2969C164.742 12.2969 165.648 13.5391 165.656 15.3281C165.648 17.125 164.719 18.3438 163.047 18.3438ZM162.031 15.3281C162.039 16.3047 162.391 16.9453 163.047 16.9531C163.719 16.9453 164.055 16.3047 164.062 15.3281C164.055 14.3516 163.75 13.6875 163.047 13.6875C162.383 13.6953 162.039 14.3672 162.031 15.3281ZM162.062 24L169.844 12.6875H171.594L163.812 24H162.062ZM168.078 21.3594C168.078 19.5703 169.039 18.3359 170.672 18.3281C172.383 18.3359 173.289 19.5703 173.297 21.3594C173.289 23.1562 172.359 24.375 170.672 24.375C168.992 24.375 168.078 23.1406 168.078 21.3594ZM169.672 21.3594C169.68 22.3359 170.031 22.9844 170.672 22.9844C171.359 22.9844 171.695 22.3359 171.703 21.3594C171.695 20.3828 171.383 19.7188 170.672 19.7344C170.016 19.7266 169.68 20.3984 169.672 21.3594Z",
    fill: "#CDD0DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.333 100C137.333 101.473 138.527 102.667 140 102.667C141.473 102.667 142.667 101.473 142.667 100C142.667 98.5272 141.473 97.3333 140 97.3333C138.527 97.3333 137.333 98.5272 137.333 100ZM41.3333 100C41.3333 101.473 42.5272 102.667 44 102.667C45.4728 102.667 46.6667 101.473 46.6667 100C46.6667 98.5272 45.4728 97.3333 44 97.3333C42.5272 97.3333 41.3333 98.5272 41.3333 100ZM140 99.5H44V100.5H140V99.5Z",
    fill: "#CDD0DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.333 19C137.333 20.4727 138.527 21.6667 140 21.6667C141.473 21.6667 142.667 20.4727 142.667 19C142.667 17.5272 141.473 16.3333 140 16.3333C138.527 16.3333 137.333 17.5272 137.333 19ZM18.3333 19C18.3333 20.4728 19.5272 21.6667 21 21.6667C22.4728 21.6667 23.6667 20.4728 23.6667 19C23.6667 17.5272 22.4728 16.3333 21 16.3333C19.5272 16.3333 18.3333 17.5272 18.3333 19ZM140 18.5L21 18.5L21 19.5L140 19.5L140 18.5Z",
    fill: "#CDD0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionMap2);
export default __webpack_public_path__ + "static/media/Section_map_2.a72c68864534326b5e848c1b33e8de88.svg";
export { ForwardRef as ReactComponent };